var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraUploadRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#camera_upload_red_svg__clip0_901_64528)",
    stroke: "#ED1B2E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.68 31.667c0 .884-.367 1.732-1.02 2.357a3.556 3.556 0 01-2.459.976h-31.3a3.556 3.556 0 01-2.459-.976 3.265 3.265 0 01-1.018-2.357V13.333c0-.884.366-1.732 1.018-2.357A3.556 3.556 0 015.902 10h6.955l3.478-5h10.433l3.478 5H37.2c.923 0 1.807.351 2.46.976a3.265 3.265 0 011.018 2.357v18.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.551 28.333c3.842 0 6.956-2.984 6.956-6.666 0-3.682-3.114-6.667-6.956-6.667-3.841 0-6.955 2.985-6.955 6.667s3.114 6.666 6.955 6.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "camera_upload_red_svg__clip0_901_64528"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.686)",
    d: "M0 0h41.733v40H0z"
  })))));
}

export default SvgCameraUploadRed;